var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{staticClass:"glance",attrs:{"size":"small","circle":""},on:{"click":_vm.onClick}},[_c('i',{staticClass:"el-icon-plus"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }